/**
 * @generated SignedSource<<6c49163ff34f2262fa4888ef6ee0737a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ObjectiveListQuery$variables = {};
export type ObjectiveListQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToObjectives: boolean;
      };
    };
    readonly hasSkippedOrSeenOkrsGettingStarted: boolean | null;
  };
};
export type ObjectiveListQuery = {
  response: ObjectiveListQuery$data;
  variables: ObjectiveListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSkippedOrSeenOkrsGettingStarted",
  "storageKey": null
},
v1 = {
  "alias": "hasAccessToObjectives",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "objectives"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"objectives\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ObjectiveListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ObjectiveListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b81ddf1467c274e9076104f0bc22b037",
    "id": null,
    "metadata": {},
    "name": "ObjectiveListQuery",
    "operationKind": "query",
    "text": "query ObjectiveListQuery {\n  viewer {\n    hasSkippedOrSeenOkrsGettingStarted\n    account {\n      billingAccount {\n        hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e7c47d900821d8d08b1cabcd7233d132";

export default node;
